import { Type } from "class-transformer";
import { observable } from "mobx";
import Contact from "./contact";
import ChargeOrderStatus from "./chargeOrderStatus";
import OrderItem from "./orderItem";
import UnpairedPayment from "./unpairedPayment";

export default class Order {
  @Type(() => UnpairedPayment)
  @observable
  payment: UnpairedPayment = new UnpairedPayment();

  @Type(() => Contact)
  @observable
  contact: Contact = new Contact();

  @observable
  status: ChargeOrderStatus;

  id: string;

  @Type(() => Date)
  expires: Date;

  @Type(() => OrderItem)
  orderItems: OrderItem[] = [new OrderItem()];
}
